import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-advanced-filteration-options',
    templateUrl: './gdo-advanced-filteration-options.component.html',
    styleUrls: ['./gdo-advanced-filteration-options.component.scss'],
    standalone: false
})
export class GdoAdvancedFilterationOptionsComponent implements OnInit {
  onFilterApply = new EventEmitter();
  mobile : boolean = false;

  transactionTypeFormGroup = new UntypedFormGroup({
    "Invoice": new UntypedFormControl(false),
    "Payment": new UntypedFormControl(false),
    "Credit": new UntypedFormControl(false),
    "Refund": new UntypedFormControl(false)
  });

  dateRangeFormGroup = new UntypedFormGroup({
    "startDate": new UntypedFormControl(""),
    "endDate": new UntypedFormControl("")
  });

  isInvoiceChecked = false;
  isPaymentChecked = false;
  isCreditChecked = false;
  isRefundChecked = false;


  constructor(
    private service:AppService,
    private dialogRef: MatDialogRef<GdoAdvancedFilterationOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    data ? data.invoice ? this.isInvoiceChecked = true : this.isInvoiceChecked = false : null;
    data ? data.payment ? this.isPaymentChecked = true : this.isPaymentChecked = false : null;
    data ? data.credit ? this.isCreditChecked = true : this.isCreditChecked = false : null;
    data ? data.refund ? this.isRefundChecked = true : this.isRefundChecked = false : null;
    data ? data.startDate && data.endDate ? this.dateRangeFormGroup = new UntypedFormGroup({
      "startDate": new UntypedFormControl(data.startDate),
      "endDate": new UntypedFormControl(data.endDate)
    }) : null : null
  }

  ngOnInit(): void {
    this.mobile = this.service.getWebviewCurrentStatus();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  onApply(): void {
    var returnObj = {
      startDate: this.dateRangeFormGroup.value.startDate,
      endDate: this.dateRangeFormGroup.value.endDate,
      payment: this.transactionTypeFormGroup.value.Payment,
      invoice: this.transactionTypeFormGroup.value.Invoice,
      refund: this.transactionTypeFormGroup.value.Refund,
      credit: this.transactionTypeFormGroup.value.Credit
    }

    this.dialogRef.close(returnObj);
    this.onFilterApply.emit();
  }
}
